import { createFileRoute } from "@tanstack/react-router";

import { SettingsAccountNotifications } from "@/features/my/settings/account/notifications";

export const Route = createFileRoute(
  "/(member)/(protected)/my/settings/account/notifications",
)({
  component: SettingsAccountNotifications,
});
